import { Footer } from 'antd/es/layout/layout'
import React from 'react'
import { FaRegCopyright } from "react-icons/fa6";
import './Footercomponent.css'

const FooterComponent = () => {
  return (
    <>
    <div className='footer d-flex align-items-center' >
     
        <span className='font-bold'>Copyright</span>
      
   <span className='font-bold'> <FaRegCopyright /> </span>
   <span className='font-bold mr-2'>2021 </span> 
    Allrightsreserved 
    </div>
    </>
  )
}

export default FooterComponent
